import {
  AutocompleteWithLabel,
  InputWithLabel,
  SwitchWithText
} from '@adotel/components'
import { useLazyQuery, useMutation } from '@apollo/client'
import { Collapse, useTheme } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import AdotelSkeleton from '../../components/AdotelSkeleton'
import PageHeader from '../../components/PageHeader'
import SectionTitle from '../../components/SectionTitle'
import {
  PMS_MAPPING_LIST_FOR_ACCOMMODATION_QUERY,
  PMS_MAPPING_LIST_FOR_CHANNEL_QUERY,
  CREATE_PMS_MAPPING_FOR_ACCOMMODATION_MUTATION,
  MODIFY_PMS_MAPPING_FOR_ACCOMMODATION_MUTATION
} from '../../graphql/accommodationPMSMapping'
import { CHANNELS_QUERY } from '../../graphql/channel'
import { getTranslate } from '../../localization'
import { ProviderAdapter } from '../../types/accommodation'
import {
  PMSMappingForAccommodation,
  PMSMappingForChannel,
  PMSMappingListForAccommodation,
  PMSMappingListForChannel,
  PMSMappingRatePlanInput,
  PMSMappingRoomTypeInput
} from '../../types/accommodationPMSMapping'
import { Channel } from '../../types/channel'
import { AccommodationDetailsContainer } from './AccommodationDetailsContainer'
import AccommodationPMSMappingBoxSkeleton from './AccommodationPMSMappingBox.skeleton'
import { ChannelDetailsContainer } from './ChannelDetailsContainer'
import { Footer } from './Footer'
import RatePlansCodeMapingModal from './RatePlansCodeMapingModal'
import RatePlansSelectionModal from './RatePlansSelectionModal'
import RoomTypesList from './RoomTypesList'
import RoomTypesListSkeleton from './RoomTypesListSkeleton'
import { buildSelectedChannels } from './channelSelection'
import { PMSMappingFilters } from './pmsMappingFilters'
import useStyles from './styles/index.styles'

type RangeType = {
  label: string
  value: 'Accommodation' | 'Channels'
}

const RANGE_ITEMS: RangeType[] = [
  {
    label: getTranslate('Accommodation'),
    value: 'Accommodation'
  },
  {
    label: getTranslate('Channels'),
    value: 'Channels'
  }
]
interface AccommodationPMSMappingProps {
  propertyCode: string | undefined
  accommodationName: string
  loadingForGetPropertyCode: boolean
}
export const AccommodationPMSMapping: React.FC<
  AccommodationPMSMappingProps
> = ({ propertyCode, accommodationName, loadingForGetPropertyCode }) => {
  const classes = useStyles()
  const theme = useTheme()

  const [searchInput, setSearchInput] = useState('')
  const [isChannelsSelected, setisChannelsSelected] = useState(false)
  const [clickOnChannelPmsMappingBox, setClickOnChannelPmsMappingBox] =
    useState(false)
  const [selectedRange, setselectedRange] = useState(0)

  const [autoCompleteLabelForChannels, setautoCompleteLabelForChannels] =
    useState<any>([])

  const [haveSuppurtRatePlans, setHaveSuppurtRatePlans] =
    useState<boolean>(false)
  const [autoCompleteForProvider, setAutoCompleteForProvider] =
    useState<any>(null)

  const [adapter, setAdapter] = useState<ProviderAdapter>('')
  const [existMapping, setExistMapping] = useState<boolean>(false)
  const [PMSMappingForAccommodationInput, setPMSMappingForAccommodationInput] =
    useState<PMSMappingForAccommodation>({
      propertyCode: propertyCode || '',
      providerCode: '',
      providerAdapter: adapter,
      active: true,
      PMSCode: '',
      PMSPass: '',
      roomTypes: [],
      supportRatePlan: false
    })

  const [PMSMappingForChannelInputs, setPMSMappingForChannelInputs] = useState<
    PMSMappingForChannel[]
  >([])

  const [PMSMappingsForChannelsData, setPMSMappingsForChannelsData] = useState<
    PMSMappingListForChannel[]
  >([])

  const [
    getPMSMappingListForAccommodation,
    {
      data: PMSMappingsAccommodationList,
      loading: loadingForPMSMappingsAccommodationList,
      refetch: refetchForAccommodationPMSMappingList
    }
  ] = useLazyQuery<{
    pmsMappingListForAccommodation: PMSMappingListForAccommodation
  }>(PMS_MAPPING_LIST_FOR_ACCOMMODATION_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    onCompleted: (resp) => {
      setExistMapping(!!resp?.pmsMappingListForAccommodation.PMSCode)

      const roomtypes: PMSMappingRoomTypeInput[] = []
      resp.pmsMappingListForAccommodation.RoomTypes.forEach((room) => {
        const rateplans: PMSMappingRatePlanInput[] = []

        if (haveSuppurtRatePlans) {
          room.RatePlans.forEach((rate) => {
            rateplans.push({
              AdotelCode: rate.AdotelCode,
              PMSCode: rate.PMSCode || ''
            })
          })
        } else {
          const foundRatePlan = room.RatePlans.find(
            (ele) => ele.PMSCode === 'NoData'
          )
          if (foundRatePlan) {
            rateplans.push({
              AdotelCode: foundRatePlan.AdotelCode,
              PMSCode: foundRatePlan.PMSCode || ''
            })
          }
        }

        roomtypes.push({
          AdotelCode: room.AdotelCode,
          PMSCode: room.PMSCode,
          ratePlans: rateplans
        })
      })

      setPMSMappingForAccommodationInput({
        ...PMSMappingForAccommodationInput,
        PMSCode: resp.pmsMappingListForAccommodation.PMSCode,
        PMSPass: resp.pmsMappingListForAccommodation.PMSPass,
        roomTypes: roomtypes
      })
    },
    onError: (err) => {
      toast.error(err.message)
    }
  })

  const [
    getPMSMappingListForChannel,
    {
      data: PMSMappingsChannelList,
      loading: loadingForPMSMappingsChannelList,
      refetch: refetchForChannelPMSMappingList
    }
  ] = useLazyQuery<{
    pmsMappingListForChannel: PMSMappingListForChannel[]
  }>(PMS_MAPPING_LIST_FOR_CHANNEL_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    onCompleted: (resp) => {
      const temp: PMSMappingListForChannel[] =
        resp.pmsMappingListForChannel.map((item) => ({
          ...item,
          isExpanded: false,
          isVisiblePassword: false,
          exist: true
        }))
      setPMSMappingsForChannelsData(temp)
    },
    onError: (err) => {
      toast.error(err.message)
    }
  })

  const [getChannels, { data: channels, loading: loadingForChannelList }] =
    useLazyQuery<{
      channels: Channel[]
    }>(CHANNELS_QUERY)

  const [
    createPMSMappingForAccommodation,
    { loading: loadingForCreatePMSMappingAccommodation }
  ] = useMutation(CREATE_PMS_MAPPING_FOR_ACCOMMODATION_MUTATION, {
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      refetchForAccommodationPMSMappingList()
      toast.success(data.createPMSMappingForAccommodation.message)
    },
    onError: (error) => {
      toast.error(error.message)
    }
  })

  const [
    modifyPMSMappingForAccommodation,
    { loading: loadingForModifyPMSMappingAccommodation }
  ] = useMutation(MODIFY_PMS_MAPPING_FOR_ACCOMMODATION_MUTATION, {
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      refetchForAccommodationPMSMappingList()
      toast.success(data.modifyPMSMappingForAccommodation.message)
    },
    onError: (error) => {
      toast.error(error.message)
    }
  })

  const handleChangeRangeSwitchWithText = (newRangeIndex: number) => {
    setselectedRange(newRangeIndex)
    setisChannelsSelected(newRangeIndex === 0 ? false : true)
  }

  useEffect(() => {
    if (
      propertyCode &&
      autoCompleteForProvider &&
      adapter &&
      selectedRange === 0
    )
      getPMSMappingListForAccommodation({
        variables: {
          propertyCode: propertyCode,
          providerCode: autoCompleteForProvider.value,
          providerAdapter: adapter
        }
      })
  }, [propertyCode, autoCompleteForProvider, adapter, selectedRange])

  useEffect(() => {
    if (
      !!propertyCode &&
      isChannelsSelected &&
      autoCompleteForProvider &&
      adapter &&
      selectedRange === 1
    )
      getPMSMappingListForChannel({
        variables: {
          propertyCode: propertyCode,
          providerCode: autoCompleteForProvider.value,
          providerAdapter: adapter
        }
      })

    getChannels()
  }, [
    propertyCode,
    isChannelsSelected,
    autoCompleteForProvider,
    adapter,
    selectedRange
  ])

  useEffect(() => {
    if (loadingForChannelList || PMSMappingsForChannelsData.length < 1) return

    // Fill dropdown
    setautoCompleteLabelForChannels(
      PMSMappingsForChannelsData.map((channel) => ({
        value: channel.AdotelCode,
        label: channel.AdotelName
      })) || []
    )

    // Create PMSMappingForChannelInputs
    const newInputs = PMSMappingsForChannelsData.map((channel) => {
      const roomTypes = channel.RoomTypes.map((room) => {
        const ratePlans: PMSMappingRatePlanInput[] = haveSuppurtRatePlans
          ? room.RatePlans.map((rate) => ({
              AdotelCode: rate.AdotelCode,
              PMSCode: rate.PMSCode || ''
            }))
          : (() => {
              const fallback = room.RatePlans.find(
                (r) => r.PMSCode === 'NoData'
              )
              return fallback
                ? [
                    {
                      AdotelCode: fallback.AdotelCode,
                      PMSCode: fallback.PMSCode || ''
                    }
                  ]
                : []
            })()

        return {
          AdotelCode: room.AdotelCode,
          PMSCode: room.PMSCode,
          ratePlans
        }
      })

      return {
        propertyCode: propertyCode || '',
        providerCode: autoCompleteForProvider?.value || '',
        providerAdapter: adapter,
        active: true,
        channelCode: channel.AdotelCode,
        PMSCode: channel.PMSCode,
        PMSPass: channel.PMSPass,
        roomTypes: roomTypes,
        supportRatePlan: haveSuppurtRatePlans
      }
    })

    setPMSMappingForChannelInputs(newInputs)
  }, [
    PMSMappingsForChannelsData,
    autoCompleteForProvider,
    adapter,
    haveSuppurtRatePlans,
    loadingForChannelList
  ])

  useEffect(() => {
    if (
      PMSMappingsAccommodationList?.pmsMappingListForAccommodation &&
      !isChannelsSelected
    ) {
      setHaveSuppurtRatePlans(
        PMSMappingsAccommodationList?.pmsMappingListForAccommodation.RoomTypes.every(
          (r) => r.RatePlans.every((item) => item.PMSCode !== 'NoData')
        )
      )
    } else if (
      PMSMappingsChannelList?.pmsMappingListForChannel &&
      isChannelsSelected
    ) {
      setHaveSuppurtRatePlans(
        PMSMappingsChannelList.pmsMappingListForChannel.every((ch) =>
          ch.RoomTypes.every((r) =>
            r.RatePlans.every((item) => item.PMSCode !== 'NoData')
          )
        )
      )
    }
  }, [
    PMSMappingsChannelList?.pmsMappingListForChannel,
    PMSMappingsAccommodationList?.pmsMappingListForAccommodation,
    isChannelsSelected
  ])

  useEffect(() => {
    setPMSMappingForAccommodationInput((prev) => ({
      ...prev,
      providerCode: autoCompleteForProvider && autoCompleteForProvider.value,
      providerAdapter: adapter,
      supportRatePlan: haveSuppurtRatePlans
    }))
  }, [autoCompleteForProvider, adapter, haveSuppurtRatePlans])

  const OnClickForSaveChanges = () => {
    if (existMapping) {
      modifyPMSMappingForAccommodation({
        variables: {
          input: PMSMappingForAccommodationInput
        }
      })
    } else {
      createPMSMappingForAccommodation({
        variables: {
          input: PMSMappingForAccommodationInput
        }
      })
    }
  }

  const handleClickOnExpandIcon = (index: number) => {
    setPMSMappingsForChannelsData([
      ...PMSMappingsForChannelsData.slice(0, index),
      {
        ...PMSMappingsForChannelsData[index],
        isExpanded: !PMSMappingsForChannelsData[index].isExpanded
      },
      ...PMSMappingsForChannelsData.slice(index + 1)
    ])

    setClickOnChannelPmsMappingBox(!clickOnChannelPmsMappingBox)
  }

  return (
    <div className={classes.root}>
      <PageHeader title={accommodationName} />
      <SectionTitle title="PMS Mapping" marginBottom />
      <div className={classes.SwitchWithText}>
        <SwitchWithText
          items={[RANGE_ITEMS[0].label, RANGE_ITEMS[1].label]}
          selectedItemIndex={selectedRange}
          onChange={handleChangeRangeSwitchWithText}
        />
      </div>
      <PMSMappingFilters
        autoCompleteForProvider={autoCompleteForProvider}
        setAutoCompleteForProvider={setAutoCompleteForProvider}
        adapter={adapter}
        setAdapter={setAdapter}
      />
      {autoCompleteForProvider && adapter && (
        <>
          <AccommodationDetailsContainer
            PMSMappingForAccommodationInput={PMSMappingForAccommodationInput}
            accommodationName={accommodationName}
            haveSuppurtRatePlans={haveSuppurtRatePlans}
            propertyCode={
              PMSMappingsAccommodationList?.pmsMappingListForAccommodation
                .AdotelCode || ''
            }
            setHaveSuppurtRatePlans={setHaveSuppurtRatePlans}
            setPMSMappingForAccommodationInput={
              setPMSMappingForAccommodationInput
            }
          />
          {isChannelsSelected ? (
            <div>
              <div>
                <AutocompleteWithLabel
                  label={getTranslate('Channels')}
                  placeholder={getTranslate('Select channels')}
                  inputSize="small"
                  options={
                    channels?.channels?.map((item) => ({
                      label: item.basicDetails.name,
                      value: item.basicDetails.displayChannelCode,
                      code: item.basicDetails.displayChannelCode
                    })) || []
                  }
                  getOptionLabel={(option) => option?.label || ''}
                  getOptionSelected={(option, value) =>
                    option.value === value.value
                  }
                  multiple
                  value={autoCompleteLabelForChannels}
                  onChange={(_, v: any) => {
                    const selectedChs = buildSelectedChannels(
                      v,
                      PMSMappingsChannelList?.pmsMappingListForChannel,
                      PMSMappingsAccommodationList
                        ?.pmsMappingListForAccommodation.RoomTypes
                    )

                    setPMSMappingsForChannelsData(selectedChs)
                  }}
                  includeInputInList
                  limitTags={3}
                  loading={loadingForChannelList}
                  loadingText={getTranslate('Loading') + '...'}
                />
              </div>
              <div>
                <InputWithLabel
                  label={getTranslate('Room Type')}
                  placeholder={getTranslate(
                    'Search in room types names & codes'
                  )}
                  autoComplete="off"
                  inputSize="small"
                  startIcon={<SearchIcon />}
                  value={searchInput}
                  onChange={(event) =>
                    setSearchInput(event.currentTarget.value)
                  }
                />
              </div>
              {loadingForGetPropertyCode || loadingForPMSMappingsChannelList
                ? Array(6)
                    .fill('')
                    .map((item, indx) => (
                      <AccommodationPMSMappingBoxSkeleton
                        key={`roomtypebox-skeleton${item}${indx.toString()}`}
                      />
                    ))
                : PMSMappingsForChannelsData &&
                  PMSMappingsForChannelsData.map((data, index) => (
                    <div key={index}>
                      <ChannelDetailsContainer
                        PMSMappingForChannelInput={
                          PMSMappingForChannelInputs[index]
                        }
                        channelName={data.AdotelName}
                        index={index}
                        isExpanded={data.isExpanded || false}
                        loadingForGetPropertyCode={loadingForGetPropertyCode}
                        loadingForPMSMappingsAccommodationList={
                          loadingForPMSMappingsAccommodationList
                        }
                        loadingForPMSMappingsChannelList={
                          loadingForPMSMappingsChannelList
                        }
                        onClickOnExpandIcon={(i) => handleClickOnExpandIcon(i)}
                        refetchForChannelPMSMappingList={
                          refetchForChannelPMSMappingList
                        }
                        PMSMappingsForChannelsData={PMSMappingsForChannelsData}
                        setPMSMappingsForChannelsData={
                          setPMSMappingsForChannelsData
                        }
                      />
                      {data.isExpanded && (
                        <Collapse in={data.isExpanded}>
                          <RoomTypesList
                            EditModal={
                              haveSuppurtRatePlans
                                ? RatePlansCodeMapingModal
                                : RatePlansSelectionModal
                            }
                            roomTypes={
                              PMSMappingsForChannelsData[index].RoomTypes
                            }
                            searchInput={searchInput}
                            channelIndex={index}
                            loading={loadingForPMSMappingsChannelList}
                            haveSuppurtRatePlans={haveSuppurtRatePlans}
                            customizedForChannel
                            PMSMappingForChannelInputs={
                              PMSMappingForChannelInputs
                            }
                            setPMSMappingForChannelInputs={
                              setPMSMappingForChannelInputs
                            }
                            channelCode={data.AdotelCode}
                          />
                        </Collapse>
                      )}
                    </div>
                  ))}
            </div>
          ) : (
            <div>
              <div>
                <InputWithLabel
                  label={getTranslate('Room Type')}
                  placeholder={getTranslate(
                    'Search in room types names & codes'
                  )}
                  autoComplete="off"
                  inputSize="small"
                  startIcon={<SearchIcon />}
                  value={searchInput}
                  onChange={(event) =>
                    setSearchInput(event.currentTarget.value)
                  }
                />
              </div>
              {PMSMappingsAccommodationList &&
              PMSMappingsAccommodationList!.pmsMappingListForAccommodation &&
              PMSMappingsAccommodationList!.pmsMappingListForAccommodation
                .RoomTypes &&
              PMSMappingsAccommodationList!.pmsMappingListForAccommodation
                .RoomTypes.length > 0 ? (
                <RoomTypesList
                  EditModal={
                    haveSuppurtRatePlans
                      ? RatePlansCodeMapingModal
                      : RatePlansSelectionModal
                  }
                  roomTypes={
                    PMSMappingsAccommodationList?.pmsMappingListForAccommodation
                      .RoomTypes
                  }
                  searchInput={searchInput}
                  loading={
                    loadingForPMSMappingsAccommodationList ||
                    loadingForGetPropertyCode
                  }
                  haveSuppurtRatePlans={haveSuppurtRatePlans}
                  PMSMappingForAccommodationInput={
                    PMSMappingForAccommodationInput
                  }
                  setPMSMappingForAccommodationInput={
                    setPMSMappingForAccommodationInput
                  }
                />
              ) : (
                <RoomTypesListSkeleton />
              )}
            </div>
          )}
          {!isChannelsSelected && (
            <Footer
              disabled={false}
              onClick={OnClickForSaveChanges}
              loading={
                loadingForCreatePMSMappingAccommodation ||
                loadingForModifyPMSMappingAccommodation
              }
            />
          )}
        </>
      )}
      <AdotelSkeleton
        open={
          loadingForGetPropertyCode || loadingForPMSMappingsAccommodationList
        }
        circlesColor={theme.palette.primary.main}
        numberOfCircles={4}
      />
    </div>
  )
}
